/**
 * @module ol/style/IconAnchorUnits
 */
/**
 * Icon anchor units. One of 'fraction', 'pixels'.
 * @enum {string}
 */
export default {
    /**
     * Anchor is a fraction
     * @api
     */
    FRACTION: 'fraction',
    /**
     * Anchor is in pixels
     * @api
     */
    PIXELS: 'pixels',
};
//# sourceMappingURL=IconAnchorUnits.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ol/style/IconAnchorUnits.js
// module id = 764
// module chunks = 8